import { useAppRouter } from '@/common/route/useAppRouter';
import { timeUnits } from '@/common/utils/helpers';
import { validateDateAfter } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_ITEM } from '@/modules/item/router';
import { itemService } from '@/services/item';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, numeric, required } from '@vuelidate/validators';
import { reactive } from 'vue';

export default function useItemSettingAdd() {
    const router = useAppRouter();

    const model = reactive({
        timeUnit: 0,
        timeDuration: 0,
        startTime: new Date()
    });

    const validations = {
        timeDuration: { required, numeric, minValue: minValue(1), maxValue: maxValue(3200) },
        startTime: { required, validateDate: validateDateAfter() }
    };

    const v$ = useVuelidate(validations, model);

    const create = useCrudActions().excuteAndNotify({
        validator: v$,
        request: () => itemService.setting.create(model.timeUnit, model.timeDuration, model.startTime.getTime()),
        onSuccess: () => router.push({ name: ROUTE_NAME_ITEM.APP_SETTING.INDEX })
    });

    return { model, v$, timeUnits, create };
}
